import { 
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  ViewEncapsulation,
  ContentChild,
  TemplateRef,
  ElementRef } from '@angular/core';
import { GalleryColumns } from 'src/app/gallery/models/gallery-list-columns.enum';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';

@Component({
  selector: 'app-gallery-cards',
  templateUrl: './gallery-cards.component.html',
  styleUrls: ['./gallery-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class GalleryCardsComponent implements OnInit {
  galleryColumns = GalleryColumns;

  @ContentChild('galleryActions', { read: TemplateRef }) 
  @Input()
  galleryActionsTemplate: TemplateRef<ElementRef>;

  @ContentChild('galleryTags', { read: TemplateRef }) 
  @Input()
  galleryTagsTemplate: TemplateRef<ElementRef>;

  @Input()
  selectLabel = 'Select';

  @Input()
  public get columns(): GalleryColumns[] {
    return this._columns;
  }
  public set columns(value: GalleryColumns[]) {
    this._columns = value;
  }
  private _columns: GalleryColumns[] = [
    GalleryColumns.Model,
    GalleryColumns.Tags,
    GalleryColumns.CreatedBy,
    GalleryColumns.UpdatedBy,
    GalleryColumns.Actions
  ];

  @Input()
  public get results(): BookmarkModel[] {
    return this._results;
  }
  public set results(value: BookmarkModel[]) {
    this._results = value;
  }
  private _results: BookmarkModel[];

  @Input()
  checkable = false;

  @Input()
  checkedResults: string[] = [];

  @Input()
  showActions = false;

  @Output()
  checkedChange = new EventEmitter<string[]>();

  @Output()
  selectBookmark = new EventEmitter<BookmarkModel>();

  constructor() { }

  ngOnInit() {
  }

  handleSelect(result: BookmarkModel) {
    this.selectBookmark.emit(result);
  }

  handleCheckedChange(value: { id: string, checked: boolean }) {
    const ids = (value.checked) ? [...this.checkedResults, value.id] : this.checkedResults.filter(id => id !== value.id);
    this.checkedChange.emit(ids);
  }

  isChecked(id: string) {
    return this.checkedResults.indexOf(id) >= 0;
  }
}
